"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeAuditlog_de_de = void 0;
function backofficeAuditlog_de_de() {
    return {
        "backoffice.auditlog.title": "Auditprotokoll",
        "backoffice.auditlog.subtitle": "Hier können Änderungen von gewissen Datensätzen nachverfolgt werden.",
        "backoffice.auditlog.user": "Änderung durch",
        "backoffice.auditlog.feature": "Datensammlung",
        "backoffice.auditlog.event": "Aktion",
        "backoffice.auditlog.targetid": "Ziel",
        "backoffice.auditlog.diff": "Unterschied",
        "backoffice.auditlog.createdat": "Datum",
        "backoffice.auditlog.owneridnotfound": "Unbekannt"
    };
}
exports.backofficeAuditlog_de_de = backofficeAuditlog_de_de;
